// @stay.ai: keep the add-to-cart button price in sync with the Stay widget's selected plan
(() => {
  const PRICE_SEL = "button[id^='ProductSubmitButton'] .btn__text span.btn__price[data-product-price]";
  const FORM_SEL = "form[action$='/cart/add']:not(.installment)";

  const money = (cents) => window.theme.formatMoney(cents, window.theme.moneyFormat);

  let productPromise;
  const getProduct = () => {
    const handle = document.querySelector("product-info[data-product-handle]")?.dataset.productHandle;
    if (!handle) return Promise.resolve(null);
    productPromise ||= fetch(`${window.theme.routes.root}products/${handle}.js`)
      .then((r) => r.json())
      .catch(() => null);
    return productPromise;
  };

  const compute = async () => {
    const form = document.querySelector(FORM_SEL);
    const product = await getProduct();
    const variantId = Number(form?.querySelector("[name='id']")?.value);
    const variant = product?.variants.find((v) => v.id === variantId);
    if (!variant) return null;

    const planId = form.querySelector("input[name='selling_plan']")?.value;
    const allocation = planId
      ? variant.selling_plan_allocations?.find((a) => String(a.selling_plan_id) === String(planId))
      : null;
    if (planId && !allocation) return null;

    const qty = parseInt(document.querySelector("[data-quantity-input]")?.value || "1", 10) || 1;
    const final = allocation ? allocation.price : variant.price;
    const original = Math.max(variant.compare_at_price || 0, variant.price);
    const finalHtml = money(final * qty);
    return original > final ? `<s>${money(original * qty)}</s> ${finalHtml}` : finalHtml;
  };

  const sync = async () => {
    const html = await compute();
    if (html === null) return;
    document.querySelectorAll(PRICE_SEL).forEach((el) => {
      if (el.innerHTML.trim() !== html) el.innerHTML = html;
    });
  };

  // Plan or purchase-type change inside the widget
  window.addEventListener("stay-ai-subscription-changed", sync);

  // The theme rewrites the button price on variant/quantity change; re-apply afterwards
  const observe = () => {
    document.querySelectorAll(PRICE_SEL).forEach((el) => {
      new MutationObserver(sync).observe(el, { childList: true, characterData: true, subtree: true });
    });
    sync();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", observe);
  else observe();
})();
